import { routes } from "@/lib/routes";

/** Contact pages own their compact chrome, including on the first server render. */
export function isTeamContactPath(pathname: string | null | undefined): boolean {
  const prefix = routes.content.teamContact("");
  return Boolean(pathname?.startsWith(prefix));
}
